import { adminHttpClient } from '../../../commons/adminHttpClient'

export type SetPlanPeriodRunoutDaysRequest = {
  planPeriodId: string
  runOutDays: number
}

const setPlanPeriodRunoutDays = (payload: SetPlanPeriodRunoutDaysRequest): Promise<void> => {
  return adminHttpClient.put('/Benefit/UpdatePlanPeriodRunOutDays', payload)
}

export default setPlanPeriodRunoutDays
